import Swiper from "https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.mjs"
const swiper = new Swiper("[js-product-slider]", {
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
})

const recommendedSlider = new Swiper("[js-recommended-slider]", {
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
	slidesPerView: "auto",
	breakpoints: {
		768: {
			slidesPerView: 4,
		},
	},
})

const initQantitySelector = () => {
	const minus = document.querySelector("[js-qa-minus]")
	const plus = document.querySelector("[js-qa-plus]")
	const input = document.querySelector("[js-qa-input]")
	const hiddenInput = document.querySelector("[js-qa-hidden-input]")
	minus.addEventListener("click", () => {
		const value = Number(input.getAttribute("data-value"))
		if (value > 1) {
			input.textContent = value - 1
			input.setAttribute("data-value", value - 1)
			hiddenInput.value = value - 1
		}
	})

	plus.addEventListener("click", () => {
		const value = Number(input.getAttribute("data-value"))
		input.textContent = value + 1
		input.setAttribute("data-value", value + 1)
		hiddenInput.value = value + 1
	})
}

const initTabs = () => {
	const tabs = document.querySelectorAll("[js-product-tab]")
	const tabContents = document.querySelectorAll("[js-tab-content]")

	const setActiveTab = (activeTab) => {
		tabs.forEach((tab) => {
			if (tab.getAttribute("data-tab-key") !== activeTab.getAttribute("data-tab-key")) return
			tab.style.borderColor = "transparent"
		})
		activeTab.style.borderColor = "#C6904F"
	}
	const setActiveContent = (tab) => {
		const tabId = tab.getAttribute("data-tab-i")
		tabContents.forEach((tabContent) => {
			if (tabContent.getAttribute("data-tab-key") !== tab.getAttribute("data-tab-key")) return
			tabContent.classList.add("hidden")
			if (tabContent.getAttribute("data-tab-i") === tabId) {
				tabContent.classList.remove("hidden")
			}
		})
	}
	const handleTabClick = (tab) => {
		setActiveTab(tab)
		setActiveContent(tab)
	}
	const assignClickHandler = (tab) => {
		tab.addEventListener("click", () => handleTabClick(tab))
	}
	tabs.forEach(assignClickHandler)
}
initQantitySelector()
initTabs()
